export const HOSTS = 'hosts';
export const LAYOUTS = 'layouts';
export const NAV = 'navigations';
